import {
  Restaurant,
  RestaurantCrmData,
  Activity,
  OverviewKpis,
  MarketRow,
  MarketOption,
  BrandOption,
  TimePeriodOption,
  UploadedList
} from './types';

// ─── Markets ───

export const MARKETS: MarketOption[] = [
  { value: 'london', label: 'London' },
  { value: 'paris', label: 'Paris' },
  { value: 'new_york', label: 'New York' },
  { value: 'tokyo', label: 'Tokyo' },
  { value: 'hong_kong', label: 'Hong Kong' }
];

export const BRANDS: BrandOption[] = [
  { value: 'margaux', label: 'Margaux' },
  { value: 'all', label: 'All Brands' }
];

export const TIME_PERIODS: TimePeriodOption[] = [
  { value: '2025_h2', label: 'H2 2025' },
  { value: '2025_h1', label: 'H1 2025' },
  { value: '2024_h2', label: 'H2 2024' },
  { value: '2024_h1', label: 'H1 2024' }
];

// ─── Restaurants (from real London market API data) ───

export const RESTAURANTS: Restaurant[] = [
  {
    store_id: 190,
    is_new_store: false,
    store_type: 'restaurant',
    state: 'pos',
    state_translated: 'Point de Vente',
    is_flow_store: false,
    continuous_mode: true,
    network_code: 'ON',
    name: '67 Pall Mall',
    evolution: 'Stable',
    displayed_currency: 'EUR',
    hotel: '',
    group: '',
    latitude: 51.5054112,
    longitude: -0.1370326,
    photo: null,
    michelin_green_star: false,
    michelin_stars: 0,
    orig_stars: '',
    ws_award: '',
    world_best: null,
    wine_service_rating: null,
    region: 'England',
    address: '67 Pall Mall',
    postal_code: 'SW1Y 5ES',
    city: 'London',
    country: 'United Kingdom',
    country_code: 'GB',
    phone: '44 2 030-006-767',
    email: 'reservations@67pallmall.com',
    site: 'https://67pallmall.co.uk/',
    dn_total: 804,
    dn_bdx: 168,
    dn_champ: 75,
    dn_italy: 137,
    dn_napa: 56,
    avg_all_price: 560.0,
    median_all_price: 233.0,
    median_btg_price: 30.0,
    checks_validity_date: '2025-08-07',
    client_bottles_details: [
      {
        entity_type: 'wine',
        entity_name: 'Margaux',
        wine_name: 'Margaux',
        vintage: '1987',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: 748,
        price: 1028,
        currency: 'GBP',
        old_local_price: 748,
        old_price: 979,
        old_currency: 'GBP',
        evolution: 'stable',
        current_checks_validity_date: '2025-08-07T00:00:00',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      },
      {
        entity_type: 'wine',
        entity_name: 'Margaux',
        wine_name: 'Margaux',
        vintage: '1982',
        format_size: '1500',
        format_group: 'large',
        wine_color: 'Red',
        local_price: 2806,
        price: 3855,
        currency: 'GBP',
        old_local_price: 2806,
        old_price: 3672,
        old_currency: 'GBP',
        evolution: 'stable',
        current_checks_validity_date: '2025-08-07T00:00:00',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      }
    ],
    rival_bottles_details: [
      {
        entity_type: 'wine',
        entity_name: 'Mouton Rothschild',
        wine_name: 'Mouton Rothschild',
        vintage: '2004',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: 748,
        price: 1028,
        currency: 'GBP',
        old_local_price: 748,
        old_price: 979,
        old_currency: 'GBP',
        evolution: 'stable',
        current_checks_validity_date: '2025-08-07T00:00:00',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      },
      {
        entity_type: 'wine',
        entity_name: 'Lafite Rothschild',
        wine_name: 'Lafite Rothschild',
        vintage: '2005',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: 960,
        price: 1319,
        currency: 'GBP',
        old_local_price: null,
        old_price: null,
        old_currency: null,
        evolution: 'won',
        current_checks_validity_date: '2025-08-07T00:00:00',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      },
      {
        entity_type: 'wine',
        entity_name: 'Haut Brion',
        wine_name: 'Haut Brion',
        vintage: '2000',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: 1000,
        price: 1374,
        currency: 'GBP',
        old_local_price: null,
        old_price: null,
        old_currency: null,
        evolution: 'won',
        current_checks_validity_date: '2025-08-07T00:00:00',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      },
      {
        entity_type: 'wine',
        entity_name: 'Cheval Blanc',
        wine_name: 'Cheval Blanc',
        vintage: '2010',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: 1405,
        price: 1930,
        currency: 'GBP',
        old_local_price: 1405,
        old_price: 1838,
        old_currency: 'GBP',
        evolution: 'stable',
        current_checks_validity_date: '2025-08-07T00:00:00',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      }
    ],
    client_refs_by_wine: { Margaux: 2 },
    rival_wines: {
      'Mouton Rothschild': 8,
      'Grand Vin de Latour': 3,
      'Lafite Rothschild': 2,
      'Haut Brion': 1,
      'Cheval Blanc': 1
    },
    active_rivals: [
      'Mouton Rothschild',
      'Grand Vin de Latour',
      'Lafite Rothschild',
      'Haut Brion',
      'Cheval Blanc'
    ],
    client_refs_by_bottle: [
      { wine_name: 'Margaux', vintage: '1987', bottle_format: '750', refs: 1 },
      { wine_name: 'Margaux', vintage: '1982', bottle_format: '1500', refs: 1 }
    ]
  },
  {
    store_id: 196,
    is_new_store: false,
    store_type: 'restaurant',
    state: 'todo',
    state_translated: 'A Conquérir',
    is_flow_store: true,
    continuous_mode: true,
    network_code: 'ON',
    name: 'Cabotte',
    evolution: '-',
    displayed_currency: 'EUR',
    hotel: '',
    group: '',
    latitude: 51.5149331,
    longitude: -0.0916843,
    photo: null,
    michelin_green_star: false,
    michelin_stars: 0,
    orig_stars: '',
    ws_award: '',
    world_best: null,
    wine_service_rating: null,
    region: 'England',
    address: '48 Gresham Street',
    postal_code: 'EC2V 7AY',
    city: 'London',
    country: 'United Kingdom',
    country_code: 'GB',
    phone: '44 2 076-001-616',
    email: 'info@cabotte.co.uk',
    site: 'http://www.cabotte.co.uk/',
    dn_total: 147,
    dn_bdx: 33,
    dn_champ: 23,
    dn_italy: 17,
    dn_napa: 5,
    avg_all_price: 438.0,
    median_all_price: 265.0,
    median_btg_price: 19.0,
    checks_validity_date: '2025-12-03',
    client_bottles_details: null,
    rival_bottles_details: [
      {
        entity_type: 'wine',
        entity_name: 'Grand Vin de Latour',
        wine_name: 'Grand Vin de Latour',
        vintage: '1985',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: 990,
        price: 1329,
        currency: 'GBP',
        old_local_price: 990,
        old_price: 1361,
        old_currency: 'GBP',
        evolution: 'stable',
        current_checks_validity_date: '2025-12-03T00:23:39',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      },
      {
        entity_type: 'wine',
        entity_name: 'Cheval Blanc',
        wine_name: 'Cheval Blanc',
        vintage: '2000',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: 1100,
        price: 1477,
        currency: 'GBP',
        old_local_price: null,
        old_price: null,
        old_currency: null,
        evolution: 'won',
        current_checks_validity_date: '2025-12-03T00:23:39',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      }
    ],
    client_refs_by_wine: null,
    rival_wines: { 'Grand Vin de Latour': 1, 'Cheval Blanc': 1 },
    active_rivals: ['Grand Vin de Latour', 'Cheval Blanc'],
    client_refs_by_bottle: []
  },
  {
    store_id: 202,
    is_new_store: false,
    store_type: 'restaurant',
    state: 'todo',
    state_translated: 'A Conquérir',
    is_flow_store: false,
    continuous_mode: true,
    network_code: 'ON',
    name: 'Elystan Street',
    evolution: '-',
    displayed_currency: 'EUR',
    hotel: '',
    group: '',
    latitude: 51.4915801,
    longitude: -0.1677161,
    photo: null,
    michelin_green_star: false,
    michelin_stars: 1,
    orig_stars: '1',
    ws_award: '',
    world_best: null,
    wine_service_rating: null,
    region: 'England',
    address: '43 Elystan Street',
    postal_code: 'SW3 3NT',
    city: 'London',
    country: 'United Kingdom',
    country_code: 'GB',
    phone: '44 2 076-285-005',
    email: 'INFO@ELYSTANSTREET.COM',
    site: 'http://www.elystanstreet.com/',
    dn_total: 107,
    dn_bdx: 29,
    dn_champ: 17,
    dn_italy: 22,
    dn_napa: 2,
    avg_all_price: 276.0,
    median_all_price: 184.0,
    median_btg_price: 26.0,
    checks_validity_date: '2025-08-07',
    client_bottles_details: null,
    rival_bottles_details: [
      {
        entity_type: 'wine',
        entity_name: 'Grand Vin de Latour',
        wine_name: 'Grand Vin de Latour',
        vintage: '1996',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: 1500,
        price: 2061,
        currency: 'GBP',
        old_local_price: 1500,
        old_price: 1923,
        old_currency: 'GBP',
        evolution: 'stable',
        current_checks_validity_date: '2025-08-07T00:00:00',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      }
    ],
    client_refs_by_wine: null,
    rival_wines: { 'Grand Vin de Latour': 1 },
    active_rivals: ['Grand Vin de Latour'],
    client_refs_by_bottle: []
  },
  {
    store_id: 216,
    is_new_store: false,
    store_type: 'restaurant',
    state: 'lost',
    state_translated: 'Perdu',
    is_flow_store: true,
    continuous_mode: true,
    network_code: 'ON',
    name: "Noble Rot - Lamb's Conduit",
    evolution: 'Perdu',
    displayed_currency: 'EUR',
    hotel: '',
    group: 'noble rot',
    latitude: 51.5218778,
    longitude: -0.1186975,
    photo: null,
    michelin_green_star: false,
    michelin_stars: 0,
    orig_stars: '',
    ws_award: '',
    world_best: null,
    wine_service_rating: null,
    region: 'England',
    address: "51 Lamb's Conduit St",
    postal_code: 'WC1N 3NB',
    city: 'London',
    country: 'United Kingdom',
    country_code: 'GB',
    phone: '44 2 072-428-963',
    email: 'reservations@noblerot.co.uk',
    site: 'http://noblerot.co.uk/wine-bar',
    dn_total: 223,
    dn_bdx: 99,
    dn_champ: 26,
    dn_italy: 16,
    dn_napa: 5,
    avg_all_price: 432.0,
    median_all_price: 242.0,
    median_btg_price: 98.0,
    checks_validity_date: '2026-01-05',
    client_bottles_details: [
      {
        entity_type: 'wine',
        entity_name: 'Margaux',
        wine_name: 'Margaux',
        vintage: '2003',
        format_size: 'glass',
        format_group: 'glass',
        wine_color: 'Red',
        local_price: null,
        price: null,
        currency: null,
        old_local_price: 116,
        old_price: 157,
        old_currency: 'GBP',
        evolution: 'lost',
        current_checks_validity_date: '2026-01-05T14:00:55',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      },
      {
        entity_type: 'wine',
        entity_name: 'Margaux',
        wine_name: 'Margaux',
        vintage: '1978',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: null,
        price: null,
        currency: null,
        old_local_price: 474,
        old_price: 642,
        old_currency: 'GBP',
        evolution: 'lost',
        current_checks_validity_date: '2026-01-05T14:00:55',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      }
    ],
    rival_bottles_details: [
      {
        entity_type: 'wine',
        entity_name: 'Mouton Rothschild',
        wine_name: 'Mouton Rothschild',
        vintage: '2004',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: 570,
        price: 779,
        currency: 'GBP',
        old_local_price: null,
        old_price: null,
        old_currency: null,
        evolution: 'won',
        current_checks_validity_date: '2026-01-05T14:00:55',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      },
      {
        entity_type: 'wine',
        entity_name: 'Haut Brion',
        wine_name: 'Haut Brion',
        vintage: '2002',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: 586,
        price: 801,
        currency: 'GBP',
        old_local_price: null,
        old_price: null,
        old_currency: null,
        evolution: 'won',
        current_checks_validity_date: '2026-01-05T14:00:55',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      },
      {
        entity_type: 'wine',
        entity_name: 'Lafite Rothschild',
        wine_name: 'Lafite Rothschild',
        vintage: '2004',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: 716,
        price: 979,
        currency: 'GBP',
        old_local_price: 642,
        old_price: 870,
        old_currency: 'GBP',
        evolution: 'stable',
        current_checks_validity_date: '2026-01-05T14:00:55',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      }
    ],
    client_refs_by_wine: { Margaux: 0 },
    rival_wines: {
      'Mouton Rothschild': 2,
      'Haut Brion': 3,
      'Lafite Rothschild': 4,
      'Cheval Blanc': 0,
      'Grand Vin de Latour': 0
    },
    active_rivals: ['Mouton Rothschild', 'Haut Brion', 'Lafite Rothschild'],
    client_refs_by_bottle: null
  },
  {
    store_id: 218,
    is_new_store: false,
    store_type: 'restaurant',
    state: 'pos',
    state_translated: 'Point de Vente',
    is_flow_store: true,
    continuous_mode: true,
    network_code: 'ON',
    name: "Otto's - Londres",
    evolution: 'Stable',
    displayed_currency: 'EUR',
    hotel: '',
    group: '',
    latitude: 51.5229187,
    longitude: -0.114261,
    photo: null,
    michelin_green_star: false,
    michelin_stars: 0,
    orig_stars: '',
    ws_award: '',
    world_best: null,
    wine_service_rating: null,
    region: 'England',
    address: "182 Gray's Inn Road",
    postal_code: 'WC1X 8EW',
    city: 'London',
    country: 'United Kingdom',
    country_code: 'GB',
    phone: '44 2 077-130-107',
    email: 'enquiries@ottos-restaurant.com',
    site: 'http://www.ottos-restaurant.com/',
    dn_total: 102,
    dn_bdx: 53,
    dn_champ: 11,
    dn_italy: 5,
    dn_napa: 1,
    avg_all_price: 1000.0,
    median_all_price: 424.0,
    median_btg_price: 18.0,
    checks_validity_date: '2025-12-02',
    client_bottles_details: [
      {
        entity_type: 'wine',
        entity_name: 'Margaux',
        wine_name: 'Margaux',
        vintage: '1995',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: 1870,
        price: 2510,
        currency: 'GBP',
        old_local_price: 1870,
        old_price: 2571,
        old_currency: 'GBP',
        evolution: 'stable',
        current_checks_validity_date: '2025-12-02T12:59:53',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      }
    ],
    rival_bottles_details: [
      {
        entity_type: 'wine',
        entity_name: 'Cheval Blanc',
        wine_name: 'Cheval Blanc',
        vintage: '1996',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: 1800,
        price: 2416,
        currency: 'GBP',
        old_local_price: 1800,
        old_price: 2474,
        old_currency: 'GBP',
        evolution: 'stable',
        current_checks_validity_date: '2025-12-02T12:59:53',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      },
      {
        entity_type: 'wine',
        entity_name: 'Mouton Rothschild',
        wine_name: 'Mouton Rothschild',
        vintage: '1995',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: 2250,
        price: 3020,
        currency: 'GBP',
        old_local_price: 2250,
        old_price: 3093,
        old_currency: 'GBP',
        evolution: 'stable',
        current_checks_validity_date: '2025-12-02T12:59:53',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      }
    ],
    client_refs_by_wine: { Margaux: 1 },
    rival_wines: {
      'Cheval Blanc': 1,
      'Grand Vin de Latour': 1,
      'Mouton Rothschild': 1,
      'Lafite Rothschild': 1
    },
    active_rivals: [
      'Cheval Blanc',
      'Grand Vin de Latour',
      'Mouton Rothschild',
      'Lafite Rothschild'
    ],
    client_refs_by_bottle: [
      { wine_name: 'Margaux', vintage: '1995', bottle_format: '750', refs: 1 }
    ]
  },
  {
    store_id: 227,
    is_new_store: false,
    store_type: 'restaurant',
    state: 'pos',
    state_translated: 'Point de Vente',
    is_flow_store: false,
    continuous_mode: true,
    network_code: 'ON',
    name: 'STK London - Strand',
    evolution: 'Stable',
    displayed_currency: 'EUR',
    hotel: 'me london',
    group: 'stk',
    latitude: 51.5117555,
    longitude: -0.1185847,
    photo: null,
    michelin_green_star: false,
    michelin_stars: 0,
    orig_stars: '',
    ws_award: 'Award of Excellence',
    world_best: null,
    wine_service_rating: null,
    region: 'England',
    address: '336-337 Strand',
    postal_code: 'W1B 4RS',
    city: 'London',
    country: 'United Kingdom',
    country_code: 'GB',
    phone: '44 2 073-953-450',
    email: '',
    site: 'https://www.melia.com/fr/hotels/royaume-uni/londres/me-london/restaurants/stk-steakhouse',
    dn_total: 106,
    dn_bdx: 11,
    dn_champ: 18,
    dn_italy: 16,
    dn_napa: 17,
    avg_all_price: null,
    median_all_price: null,
    median_btg_price: null,
    checks_validity_date: '2025-08-07',
    client_bottles_details: [
      {
        entity_type: 'wine',
        entity_name: 'Margaux',
        wine_name: 'Margaux',
        vintage: '1986',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: null,
        price: null,
        currency: 'GBP',
        old_local_price: 1560,
        old_price: 1815,
        old_currency: 'GBP',
        evolution: 'stable',
        current_checks_validity_date: '2025-08-07T00:00:00',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      },
      {
        entity_type: 'wine',
        entity_name: 'Margaux',
        wine_name: 'Margaux',
        vintage: '2002',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: null,
        price: null,
        currency: 'GBP',
        old_local_price: null,
        old_price: null,
        old_currency: null,
        evolution: 'won',
        current_checks_validity_date: '2025-08-07T00:00:00',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      }
    ],
    rival_bottles_details: [
      {
        entity_type: 'wine',
        entity_name: 'Lafite Rothschild',
        wine_name: 'Lafite Rothschild',
        vintage: '2008',
        format_size: '750',
        format_group: 'bottle',
        wine_color: 'Red',
        local_price: null,
        price: null,
        currency: 'GBP',
        old_local_price: 2160,
        old_price: 2513,
        old_currency: 'GBP',
        evolution: 'stable',
        current_checks_validity_date: '2025-08-07T00:00:00',
        previous_checks_validity_date: '2024-06-04T00:00:00'
      }
    ],
    client_refs_by_wine: { Margaux: 2 },
    rival_wines: { 'Lafite Rothschild': 1, 'Haut Brion': 1 },
    active_rivals: ['Lafite Rothschild', 'Haut Brion'],
    client_refs_by_bottle: [
      { wine_name: 'Margaux', vintage: '1986', bottle_format: '750', refs: 1 },
      { wine_name: 'Margaux', vintage: '2002', bottle_format: '750', refs: 1 }
    ]
  },
  {
    store_id: 208,
    is_new_store: false,
    store_type: 'restaurant',
    state: 'other',
    state_translated: 'Autre',
    is_flow_store: false,
    continuous_mode: true,
    network_code: 'ON',
    name: 'Hawksmoor - Seven Dials',
    evolution: '-',
    displayed_currency: 'EUR',
    hotel: '',
    group: 'hawksmoor',
    latitude: 51.5134879,
    longitude: -0.1257456,
    photo: null,
    michelin_green_star: false,
    michelin_stars: 0,
    orig_stars: '',
    ws_award: '',
    world_best: null,
    wine_service_rating: null,
    region: 'England',
    address: '11 Langley Street',
    postal_code: 'WC2H 9JL',
    city: 'London',
    country: 'United Kingdom',
    country_code: 'GB',
    phone: '44 2 074-209-390',
    email: 'sevendials@thehawksmoor.com',
    site: 'http://www.thehawksmoor.com/locations/seven-dials',
    dn_total: 47,
    dn_bdx: 7,
    dn_champ: 5,
    dn_italy: 10,
    dn_napa: 7,
    avg_all_price: 296.0,
    median_all_price: 233.0,
    median_btg_price: 28.0,
    checks_validity_date: '2025-08-07',
    client_bottles_details: null,
    rival_bottles_details: null,
    client_refs_by_wine: null,
    rival_wines: { 'Cheval Blanc': 0 },
    active_rivals: [],
    client_refs_by_bottle: []
  },
  {
    store_id: 197,
    is_new_store: false,
    store_type: 'restaurant',
    state: 'other',
    state_translated: 'Autre',
    is_flow_store: true,
    continuous_mode: true,
    network_code: 'ON',
    name: 'Ceru - South Kensington',
    evolution: '-',
    displayed_currency: 'EUR',
    hotel: '',
    group: 'ceru',
    latitude: 51.4934256,
    longitude: -0.176283,
    photo: null,
    michelin_green_star: false,
    michelin_stars: 0,
    orig_stars: '',
    ws_award: '',
    world_best: null,
    wine_service_rating: null,
    region: 'England',
    address: '7-9 Bute Street',
    postal_code: 'SW7 3EY',
    city: 'London',
    country: 'United Kingdom',
    country_code: 'GB',
    phone: '44 2 031-953-001',
    email: 'southken@cerurestaurants.com',
    site: 'https://www.cerurestaurants.com/southken',
    dn_total: 1,
    dn_bdx: 0,
    dn_champ: 0,
    dn_italy: 0,
    dn_napa: 0,
    avg_all_price: 138.0,
    median_all_price: 138.0,
    median_btg_price: null,
    checks_validity_date: '2025-12-02',
    client_bottles_details: null,
    rival_bottles_details: null,
    client_refs_by_wine: null,
    rival_wines: null,
    active_rivals: [],
    client_refs_by_bottle: []
  },
  {
    store_id: 210,
    is_new_store: false,
    store_type: 'restaurant',
    state: 'other',
    state_translated: 'Autre',
    is_flow_store: false,
    continuous_mode: true,
    network_code: 'ON',
    name: 'Indigo',
    evolution: '-',
    displayed_currency: 'EUR',
    hotel: 'one aldwych',
    group: '',
    latitude: 51.5117908,
    longitude: -0.11934,
    photo: null,
    michelin_green_star: false,
    michelin_stars: 0,
    orig_stars: '',
    ws_award: '',
    world_best: null,
    wine_service_rating: null,
    region: 'England',
    address: '1 Aldwych',
    postal_code: 'WC2B 4BZ',
    city: 'London',
    country: 'United Kingdom',
    country_code: 'GB',
    phone: '44 2 073-000-400',
    email: 'foodandbeveragereservations@onealdwych.com',
    site: 'https://www.onealdwych.com/food-drink/indigo',
    dn_total: 51,
    dn_bdx: 12,
    dn_champ: 22,
    dn_italy: 8,
    dn_napa: 1,
    avg_all_price: 247.0,
    median_all_price: 185.0,
    median_btg_price: 26.0,
    checks_validity_date: '2025-08-07',
    client_bottles_details: null,
    rival_bottles_details: null,
    client_refs_by_wine: null,
    rival_wines: null,
    active_rivals: [],
    client_refs_by_bottle: []
  },
  {
    store_id: 214,
    is_new_store: false,
    store_type: 'restaurant',
    state: 'other',
    state_translated: 'Autre',
    is_flow_store: true,
    continuous_mode: true,
    network_code: 'ON',
    name: 'Luca',
    evolution: '-',
    displayed_currency: 'EUR',
    hotel: '',
    group: '',
    latitude: 51.5220361,
    longitude: -0.1016722,
    photo: null,
    michelin_green_star: false,
    michelin_stars: 1,
    orig_stars: '1',
    ws_award: '',
    world_best: null,
    wine_service_rating: null,
    region: 'England',
    address: '88 St. John Street',
    postal_code: 'EC1M 4EL',
    city: 'London',
    country: 'United Kingdom',
    country_code: 'GB',
    phone: '44 2 038-593-000',
    email: 'reservations@luca.restaurant',
    site: 'https://luca.restaurant/',
    dn_total: 70,
    dn_bdx: 1,
    dn_champ: 11,
    dn_italy: 57,
    dn_napa: 0,
    avg_all_price: 430.0,
    median_all_price: 382.0,
    median_btg_price: 30.0,
    checks_validity_date: '2026-01-05',
    client_bottles_details: null,
    rival_bottles_details: null,
    client_refs_by_wine: null,
    rival_wines: null,
    active_rivals: [],
    client_refs_by_bottle: []
  },
  {
    store_id: 238,
    is_new_store: false,
    store_type: 'restaurant',
    state: 'other',
    state_translated: 'Autre',
    is_flow_store: true,
    continuous_mode: true,
    network_code: 'ON',
    name: 'The Jugged Hare',
    evolution: '-',
    displayed_currency: 'EUR',
    hotel: 'the montcalm at the brewery',
    group: '',
    latitude: 51.5209433,
    longitude: -0.0922084,
    photo: null,
    michelin_green_star: false,
    michelin_stars: 0,
    orig_stars: '',
    ws_award: '',
    world_best: null,
    wine_service_rating: null,
    region: 'England',
    address: '49 Chiswell Street',
    postal_code: 'EC1Y 4SB',
    city: 'London',
    country: 'United Kingdom',
    country_code: 'GB',
    phone: '44 2 087-610-190',
    email: 'info@thejuggedhare.com',
    site: 'http://www.thejuggedhare.com/',
    dn_total: 31,
    dn_bdx: 6,
    dn_champ: 9,
    dn_italy: 6,
    dn_napa: 0,
    avg_all_price: 162.0,
    median_all_price: 115.0,
    median_btg_price: 22.0,
    checks_validity_date: '2025-12-02',
    client_bottles_details: null,
    rival_bottles_details: null,
    client_refs_by_wine: null,
    rival_wines: null,
    active_rivals: [],
    client_refs_by_bottle: []
  },
  {
    store_id: 248,
    is_new_store: false,
    store_type: 'restaurant',
    state: 'other',
    state_translated: 'Autre',
    is_flow_store: false,
    continuous_mode: true,
    network_code: 'ON',
    name: 'Zayna',
    evolution: '-',
    displayed_currency: 'EUR',
    hotel: '',
    group: '',
    latitude: 51.5149792,
    longitude: -0.1582701,
    photo: null,
    michelin_green_star: false,
    michelin_stars: 0,
    orig_stars: '',
    ws_award: '',
    world_best: null,
    wine_service_rating: null,
    region: 'England',
    address: '25 New Quebec Street',
    postal_code: 'W1H 7SF',
    city: 'London',
    country: 'United Kingdom',
    country_code: 'GB',
    phone: '44 2 077-232-229',
    email: 'info@zaynarestaurant.co.uk',
    site: 'http://www.zaynarestaurant.co.uk/',
    dn_total: 46,
    dn_bdx: 3,
    dn_champ: 3,
    dn_italy: 0,
    dn_napa: 0,
    avg_all_price: 148.0,
    median_all_price: 111.0,
    median_btg_price: 13.0,
    checks_validity_date: '2025-08-07',
    client_bottles_details: null,
    rival_bottles_details: null,
    client_refs_by_wine: null,
    rival_wines: null,
    active_rivals: [],
    client_refs_by_bottle: []
  },
  {
    store_id: 249,
    is_new_store: false,
    store_type: 'restaurant',
    state: 'other',
    state_translated: 'Autre',
    is_flow_store: false,
    continuous_mode: true,
    network_code: 'ON',
    name: 'The French Table',
    evolution: '-',
    displayed_currency: 'EUR',
    hotel: '',
    group: '',
    latitude: 51.3950659,
    longitude: -0.3077355,
    photo: null,
    michelin_green_star: false,
    michelin_stars: 0,
    orig_stars: '',
    ws_award: '',
    world_best: null,
    wine_service_rating: null,
    region: 'England',
    address: '85 Maple Road',
    postal_code: 'KT6 4AW',
    city: 'London',
    country: 'United Kingdom',
    country_code: 'GB',
    phone: '44 2 083-992-365',
    email: 'enquiries@thefrenchtable.co.uk',
    site: 'http://www.thefrenchtable.co.uk/',
    dn_total: 21,
    dn_bdx: 14,
    dn_champ: 3,
    dn_italy: 0,
    dn_napa: 3,
    avg_all_price: 143.0,
    median_all_price: 115.0,
    median_btg_price: 10.0,
    checks_validity_date: '2025-08-07',
    client_bottles_details: null,
    rival_bottles_details: null,
    client_refs_by_wine: null,
    rival_wines: null,
    active_rivals: [],
    client_refs_by_bottle: []
  },
  {
    store_id: 280,
    is_new_store: false,
    store_type: 'restaurant',
    state: 'other',
    state_translated: 'Autre',
    is_flow_store: true,
    continuous_mode: true,
    network_code: 'ON',
    name: "Fischer's",
    evolution: '-',
    displayed_currency: 'EUR',
    hotel: '',
    group: '',
    latitude: 51.5193,
    longitude: -0.1587,
    photo: null,
    michelin_green_star: false,
    michelin_stars: 0,
    orig_stars: '',
    ws_award: '',
    world_best: null,
    wine_service_rating: null,
    region: 'England',
    address: '50 Marylebone High Street',
    postal_code: 'W1U 5HN',
    city: 'London',
    country: 'United Kingdom',
    country_code: 'GB',
    phone: '44 2 074-665-501',
    email: 'info@fischers.co.uk',
    site: 'https://www.fischers.co.uk/',
    dn_total: 42,
    dn_bdx: 5,
    dn_champ: 8,
    dn_italy: 4,
    dn_napa: 2,
    avg_all_price: 195.0,
    median_all_price: 150.0,
    median_btg_price: 18.0,
    checks_validity_date: '2025-12-02',
    client_bottles_details: null,
    rival_bottles_details: null,
    client_refs_by_wine: null,
    rival_wines: null,
    active_rivals: [],
    client_refs_by_bottle: []
  }
];

// ─── CRM data overlay (demo activities & statuses) ───

export const INITIAL_CRM_DATA: RestaurantCrmData[] = [
  {
    restaurant_id: 190,
    crm_status: 'active',
    last_contact_date: '2026-03-15',
    assigned_to: 'Sophie Martin',
    priority: 'high',
    tags: ['key_account', 'fine_dining'],
    activities: [
      {
        id: 'act-001',
        restaurant_id: 190,
        type: 'visit',
        date: '2026-03-15',
        notes:
          'Met with sommelier. Discussed new vintage allocation for 2024 Margaux. Very receptive.',
        outcome: 'positive',
        created_at: '2026-03-15T14:30:00'
      },
      {
        id: 'act-002',
        restaurant_id: 190,
        type: 'email',
        date: '2026-02-20',
        notes: 'Sent updated price list and tasting notes for 2023 vintage.',
        outcome: 'neutral',
        created_at: '2026-02-20T09:15:00'
      },
      {
        id: 'act-003',
        restaurant_id: 190,
        type: 'tasting',
        date: '2026-01-10',
        notes:
          'Private tasting of 2022 Margaux with wine director. Excellent feedback, potential 6-bottle order.',
        outcome: 'positive',
        created_at: '2026-01-10T16:00:00'
      }
    ],
    wine_list_history: [
      {
        collection_date: '2022-09-12',
        collection_method: 'online',
        client_status: 'won',
        client_refs: 1,
        total_refs: 720,
        notes: 'First listing detected — online scan'
      },
      {
        collection_date: '2023-06-04',
        collection_method: 'online',
        client_status: 'stable',
        client_refs: 1,
        total_refs: 750
      },
      {
        collection_date: '2024-06-04',
        collection_method: 'online',
        client_status: 'won',
        client_refs: 2,
        total_refs: 780,
        notes: 'Magnum listing added'
      },
      {
        collection_date: '2025-08-07',
        collection_method: 'online',
        client_status: 'stable',
        client_refs: 2,
        total_refs: 804
      }
    ]
  },
  {
    restaurant_id: 218,
    crm_status: 'active',
    last_contact_date: '2026-03-10',
    assigned_to: 'Sophie Martin',
    priority: 'medium',
    tags: ['bordeaux_specialist'],
    activities: [
      {
        id: 'act-004',
        restaurant_id: 218,
        type: 'call',
        date: '2026-03-10',
        notes:
          'Quarterly check-in with owner. Happy with current listing. Wants to explore magnums.',
        outcome: 'positive',
        created_at: '2026-03-10T11:00:00'
      },
      {
        id: 'act-005',
        restaurant_id: 218,
        type: 'visit',
        date: '2025-12-05',
        notes:
          'Delivered Christmas allocation. Good relationship, restaurant very loyal.',
        outcome: 'positive',
        created_at: '2025-12-05T15:30:00'
      }
    ],
    wine_list_history: [
      {
        collection_date: '2023-11-20',
        collection_method: 'offline',
        client_status: 'won',
        client_refs: 1,
        total_refs: 95,
        notes: 'Wine list collected during visit'
      },
      {
        collection_date: '2024-06-04',
        collection_method: 'online',
        client_status: 'stable',
        client_refs: 1,
        total_refs: 98
      },
      {
        collection_date: '2025-12-02',
        collection_method: 'online',
        client_status: 'stable',
        client_refs: 1,
        total_refs: 102
      }
    ]
  },
  {
    restaurant_id: 227,
    crm_status: 'active',
    last_contact_date: '2026-02-28',
    assigned_to: 'Jean Dupont',
    priority: 'medium',
    tags: ['hotel', 'international_chain'],
    activities: [
      {
        id: 'act-006',
        restaurant_id: 227,
        type: 'email',
        date: '2026-02-28',
        notes: 'Follow-up on new vintage. Awaiting response from F&B director.',
        outcome: 'pending',
        created_at: '2026-02-28T10:00:00'
      }
    ],
    wine_list_history: [
      {
        collection_date: '2023-01-08',
        collection_method: 'online',
        client_status: 'won',
        client_refs: 1,
        total_refs: 90,
        notes: 'Initial online listing found'
      },
      {
        collection_date: '2024-06-04',
        collection_method: 'online',
        client_status: 'stable',
        client_refs: 1,
        total_refs: 95
      },
      {
        collection_date: '2025-08-07',
        collection_method: 'online',
        client_status: 'won',
        client_refs: 2,
        total_refs: 106,
        notes: 'New vintage added'
      }
    ]
  },
  {
    restaurant_id: 216,
    crm_status: 'lost',
    last_contact_date: '2025-11-15',
    assigned_to: 'Sophie Martin',
    priority: 'high',
    tags: ['wine_bar', 'win_back_target'],
    activities: [
      {
        id: 'act-007',
        restaurant_id: 216,
        type: 'call',
        date: '2025-11-15',
        notes:
          'Spoke with new sommelier. They changed supplier. Interested in a tasting to reconsider.',
        outcome: 'neutral',
        created_at: '2025-11-15T14:00:00'
      },
      {
        id: 'act-008',
        restaurant_id: 216,
        type: 'visit',
        date: '2025-09-20',
        notes:
          'Found out they delisted us. Budget constraints and new sommelier prefers Burgundy focus.',
        outcome: 'negative',
        created_at: '2025-09-20T17:00:00'
      }
    ],
    wine_list_history: [
      {
        collection_date: '2022-03-15',
        collection_method: 'offline',
        client_status: 'won',
        client_refs: 1,
        total_refs: 190,
        notes: 'Wine list obtained during visit'
      },
      {
        collection_date: '2023-04-10',
        collection_method: 'offline',
        client_status: 'won',
        client_refs: 2,
        total_refs: 205,
        notes: 'Glass pour added'
      },
      {
        collection_date: '2024-06-04',
        collection_method: 'online',
        client_status: 'stable',
        client_refs: 2,
        total_refs: 215
      },
      {
        collection_date: '2026-01-05',
        collection_method: 'online',
        client_status: 'lost',
        client_refs: 0,
        total_refs: 223,
        notes: 'Both references delisted'
      }
    ]
  },
  {
    restaurant_id: 196,
    crm_status: 'to_win_over',
    last_contact_date: '2026-03-01',
    assigned_to: 'Jean Dupont',
    priority: 'high',
    tags: ['bordeaux_focus', 'high_potential'],
    activities: [
      {
        id: 'act-009',
        restaurant_id: 196,
        type: 'tasting',
        date: '2026-03-01',
        notes:
          'Arranged tasting with head sommelier. They carry Latour and Cheval Blanc but no Margaux. Very interested.',
        outcome: 'positive',
        created_at: '2026-03-01T12:00:00'
      }
    ]
  },
  {
    restaurant_id: 202,
    crm_status: 'to_win_over',
    last_contact_date: '2026-01-20',
    assigned_to: 'Jean Dupont',
    priority: 'medium',
    tags: ['michelin', 'high_potential'],
    activities: [
      {
        id: 'act-010',
        restaurant_id: 202,
        type: 'email',
        date: '2026-01-20',
        notes: 'Initial outreach to wine buyer. No response yet.',
        outcome: 'pending',
        created_at: '2026-01-20T09:00:00'
      }
    ]
  },
  {
    restaurant_id: 208,
    crm_status: 'prospect',
    last_contact_date: null,
    assigned_to: null,
    priority: 'low',
    tags: ['steakhouse_chain'],
    activities: []
  },
  {
    restaurant_id: 197,
    crm_status: 'inactive',
    last_contact_date: null,
    assigned_to: null,
    priority: 'low',
    tags: [],
    activities: []
  },
  {
    restaurant_id: 210,
    crm_status: 'prospect',
    last_contact_date: null,
    assigned_to: null,
    priority: 'medium',
    tags: ['hotel'],
    activities: []
  },
  {
    restaurant_id: 214,
    crm_status: 'prospect',
    last_contact_date: null,
    assigned_to: null,
    priority: 'low',
    tags: ['italian_focus'],
    activities: []
  },
  {
    restaurant_id: 238,
    crm_status: 'prospect',
    last_contact_date: null,
    assigned_to: null,
    priority: 'low',
    tags: [],
    activities: []
  },
  {
    restaurant_id: 248,
    crm_status: 'inactive',
    last_contact_date: null,
    assigned_to: null,
    priority: 'low',
    tags: [],
    activities: []
  },
  {
    restaurant_id: 249,
    crm_status: 'prospect',
    last_contact_date: null,
    assigned_to: null,
    priority: 'low',
    tags: ['bordeaux_focus'],
    activities: []
  },
  {
    restaurant_id: 280,
    crm_status: 'prospect',
    last_contact_date: null,
    assigned_to: null,
    priority: 'low',
    tags: [],
    activities: []
  }
];

// ─── KPIs (computed from the restaurant set above) ───

export const OVERVIEW_KPIS: OverviewKpis = {
  roi: {
    ws_subscription_cost: 2000,
    upsell: 4560,
    roi_percent: 228
  },
  performance: {
    numerical_distribution: 4,
    numerical_distribution_prev: 3,
    won: 1,
    lost: 1,
    win_back: 1,
    consumption_rate: 80,
    recurring_percent: 50
  },
  opportunities: {
    competitor_dn: 10,
    competitor_dn_prev: 8,
    panel_dn: 20,
    panel_dn_prev: 17,
    market_share: 29,
    market_share_prev: 25,
    market_penetration: 15,
    market_penetration_prev: 12,
    to_win_over: 3,
    panel_to_win_over: 6
  }
};

export const MARKET_ROWS: MarketRow[] = [
  {
    market: 'London',
    numerical_distribution: 4,
    won: 1,
    lost: 1,
    win_back: 1,
    consumption_rate: 80,
    recurring_percent: 50,
    competitor_dn: 10,
    panel_dn: 20,
    market_share: 29,
    market_penetration: 15,
    to_win_over: 3,
    panel_to_win_over: 6
  },
  {
    market: 'Paris',
    numerical_distribution: 12,
    won: 3,
    lost: 0,
    win_back: 0,
    consumption_rate: 92,
    recurring_percent: 75,
    competitor_dn: 18,
    panel_dn: 35,
    market_share: 40,
    market_penetration: 22,
    to_win_over: 5,
    panel_to_win_over: 9
  },
  {
    market: 'New York',
    numerical_distribution: 6,
    won: 2,
    lost: 1,
    win_back: 1,
    consumption_rate: 70,
    recurring_percent: 60,
    competitor_dn: 15,
    panel_dn: 30,
    market_share: 28,
    market_penetration: 14,
    to_win_over: 4,
    panel_to_win_over: 8
  },
  {
    market: 'Tokyo',
    numerical_distribution: 3,
    won: 1,
    lost: 0,
    win_back: 0,
    consumption_rate: 85,
    recurring_percent: 67,
    competitor_dn: 8,
    panel_dn: 16,
    market_share: 27,
    market_penetration: 16,
    to_win_over: 2,
    panel_to_win_over: 4
  },
  {
    market: 'Hong Kong',
    numerical_distribution: 5,
    won: 0,
    lost: 2,
    win_back: 2,
    consumption_rate: 65,
    recurring_percent: 40,
    competitor_dn: 12,
    panel_dn: 24,
    market_share: 29,
    market_penetration: 17,
    to_win_over: 3,
    panel_to_win_over: 5
  }
];

// ─── Sample Uploaded Lists ───

export const INITIAL_LISTS: UploadedList[] = [
  {
    id: 'list-london-q2',
    name: 'London Q2 Targets',
    store_ids: [190, 202, 216, 340],
    created_at: '2025-10-15T10:30:00Z',
    row_count: 5
  },
  {
    id: 'list-top-prospects',
    name: 'Top Prospects 2025',
    store_ids: [196, 202, 538],
    created_at: '2025-11-02T14:00:00Z',
    row_count: 3
  }
];
